import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'

import { Portal, type PortalProps } from '@material-ui/core'

import { SheetContent } from './components/SheetContent/SheetContent'
import { SheetHeader } from './components/SheetHeader/SheetHeader'
import { InternalSheetProvider } from './InternalSheetContext'
import { useSheet } from './SheetContext'
import { SheetStyled } from './styles/SheetStyled'

export interface ISheetProps {
  container?: PortalProps['container']
  isOpen: boolean
}

export const Sheet = ({
  children,
  container,
  isOpen,
}: PropsWithChildren<ISheetProps>) => {
  const { setIsSheetOpen } = useSheet()

  useEffect(() => {
    if (!isOpen) return

    setIsSheetOpen(isOpen)

    return () => setIsSheetOpen(false)
  }, [isOpen, setIsSheetOpen])

  if (!isOpen) return null

  return (
    <Portal container={container}>
      <SheetStyled>
        <InternalSheetProvider value={{ isOpen, setIsSheetOpen }}>
          {children}
        </InternalSheetProvider>
      </SheetStyled>
    </Portal>
  )
}

Sheet.Header = SheetHeader
Sheet.Content = SheetContent
Sheet.displayName = 'Sheet'
